import { useCallback, useEffect, useState } from 'react';
export const useExpandableView = ({ ref, }) => {
    const [isWidthOverflowed, setIsWidthOverflowed] = useState(false);
    const [isHeightOverflowed, setIsHeightOverflowed] = useState(false);
    const handleResize = useCallback(() => {
        if (ref.current != null) {
            const { offsetWidth, scrollWidth, offsetHeight, scrollHeight, } = ref.current;
            setIsWidthOverflowed(offsetWidth < scrollWidth);
            setIsHeightOverflowed(offsetHeight < scrollHeight);
        }
    }, [ref]);
    useEffect(() => {
        handleResize();
        document.addEventListener('resize', handleResize);
        return () => {
            document.removeEventListener('resize', handleResize);
        };
    }, [ref]);
    return {
        isWidthOverflowed,
        isHeightOverflowed,
    };
};
//# sourceMappingURL=useExpandableView.js.map